import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { HTMLAttributes } from "react";
import { FormLabelValidationState } from "../types";
import { formLabelColorTheme } from "./formLabelColorTheme";

interface FormLabelIconProps extends HTMLAttributes<HTMLDivElement> {
    themeMode: RequiredThemeKeys;
    validationState: FormLabelValidationState;
}

export const FormLabelIcon = styled("div")<FormLabelIconProps>`
    display: flex;
    color: ${({ themeMode, validationState }) => formLabelColorTheme.color[validationState](themeMode)};
`;
